/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q2_C4Inputs */



/**
* | output |
* | --- |
* | "Use only what it was given, never guess" |
*
* @param {Uno_Field_Assistant_Prompt_Q2_C4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q2_c4 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q2_C4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q2_C4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Vorhandenes nutzen, nichts raten")
	return /** @type {LocalizedString} */ ("Use only what it was given, never guess")
});